import { CREATE_HOLIDAY_ROUTE_ID, HOLIDAY_ROUTE_ID } from './common';
import HolidayList from './index';
import CreateHoliday from './holidays';

export default {
    [HOLIDAY_ROUTE_ID]: () => <HolidayList />,
    [CREATE_HOLIDAY_ROUTE_ID]: () => <CreateHoliday />,
};
